import {
  routerOrderGetData,
  routerOrderAddData,
  routerOrderUpdateData,
  routerOrderUpdate,
  routerOrderDeleteData,
  adjustOrderValidateCar,
  routerOrderMatchOrder
} from '@/api/api'

import {
  dealGasRouteOrder
} from '@/cllib/sys_lib'

import {
  getArrivalTime
} from '@/cllib/use_car_time'

import {
  dateOperating
} from '@/cllib/tools'

const state = {
  routerOrder: [],
  routerOrderLoading: false,
  carLineLoadTag: 0,
  routerOrderTimeParm: null,
  chooseOrders: {
    cabin_1: null,
    cabin_2: null,
    cabin_3: null,
    cabin_4: null,
    cabin_5: null
  },
  adjustOrderAddRouterOrdering: false,
  ordereAppendCarLine: []
}

const getters = {
  adjustOrderAddRouterOrdering: state => state.adjustOrderAddRouterOrdering,
  routerOrder: state => state.routerOrder,
  routerOrderTimeParm: state => state.routerOrderTimeParm,
  routerOrderLoading: state => state.routerOrderLoading,
  chooseOrders: state => state.chooseOrders,
  ordereAppendCarLine: state => state.ordereAppendCarLine,
  carLineLoadTag: state => state.carLineLoadTag
}

const createRouterOrder = (car, carBIn, order, date, startTime, beforeLongMap) => {
  let routerOrder = {}
  let beforeLong = beforeLongMap[order.gasTankId]
  routerOrder.expectArriveTime = getArrivalTime(startTime, beforeLong)
  routerOrder.sendTime = date
  routerOrder.gasId = order.gasId
  routerOrder.gasTankId = order.gasTankId
  routerOrder.gasOrderId = order.id
  routerOrder.volume = carBIn.validCapacity
  routerOrder.depotId = order.depotId
  routerOrder.carId = car.id
  routerOrder.carCabinNo = carBIn.carBinNo
  return routerOrder
}

const getOrderById = (orders, id) => {
  let order = {}
  orders.forEach((item) => {
    if (item.id === id) {
      order = item
    }
  })
  return order
}

const checkCarBin = (index, carbinList, order) => {
  return carbinList.length > index && order.oilName.includes(carbinList[index].oilType)
}

const actions = {
  matchOrderNew ({ dispatch }, parm) {
    dispatch('setMatchLoading', true)
    return routerOrderMatchOrder(parm).then(() => {
      dispatch('getMatchStatus')
    }).catch(() => {
      dispatch('setMatchLoading', false)
    })
  },
  loadRouterOrder ({ dispatch, getters }) {
    if (!getters.chooseRouterCar || !getters.chooseRouterCar.id) {
      return
    }
    dispatch('setRouterOrderLoading', true)
    let parm = {
      noPage: 1,
      sendTime: getters.adjustDate,
      endTime: dateOperating.computeDay({days: 1, date: getters.adjustDate, format: 'yy-mm-dd'}),
      carId: getters.chooseRouterCar.id
    }
    routerOrderGetData(parm).then((data) => {
      dispatch('setRouterOrder', dealGasRouteOrder(data))
      dispatch('setRouterOrderLoading', false)
    }).catch((e) => {
      dispatch('setRouterOrderLoading', false)
    })
  },
  setAdjustOrderAddRouterOrdering ({ commit }, data) {
    commit('setAdjustOrderAddRouterOrdering', data)
  },
  setRouterOrderTimeParm ({ commit }, data) {
    commit('setRouterOrderTimeParm', data)
  },
  setRouterOrderLoading ({ commit }, data) {
    commit('setRouterOrderLoading', data)
  },
  setRouterOrder ({ dispatch, commit }, data) {
    commit('setRouterOrder', data)
  },
  adjustOrderValidateCar ({ dispatch, commit, getters }) {
    if (getters.adjustShowRouteOrderType !== 'car' || !getters.chooseRouterCar.id || getters.adjustOrderAddRouterOrdering) {
      return
    }
    dispatch('setAdjustOrderAddRouterOrdering', true)
    let parm = {
      sendTime: getters.adjustDate,
      carId: getters.chooseRouterCar.id
    }
    return adjustOrderValidateCar(parm).then(() => {
      dispatch('addRouterOrder')
      commit('carLineLoadTag')
    }).catch((e) => {
      dispatch('setAdjustOrderAddRouterOrdering', false)
    })
  },
  addRouterOrder ({ dispatch, commit, getters }) {
    if (!getters.routerOrderTimeParm || !getters.routerOrderTimeParm.beforeLong || !getters.routerOrderTimeParm.start) {
      dispatch('showNoticeMsg', {type: 'warning', title: '无法保存计划', message: '无时间参数!'})
      dispatch('setAdjustOrderAddRouterOrdering', false)
      return
    }
    let beforeLongMap = {}
    getters.routerOrderTimeParm.beforeLong.forEach((item) => {
      beforeLongMap[item['gasTankId']] = item['beforeLong']
    })
    let routerOrders = []
    let carbinList = getters.chooseRouterCar.carbinList || []
    // 是否异站搭仓
    let i = 0
    while (i < 5) {
      if (carbinList[i] && getters.chooseOrders['cabin_' + (i + 1)]) {
        routerOrders.push(createRouterOrder(getters.chooseRouterCar, carbinList[i], getOrderById(getters.allOrder, getters.chooseOrders['cabin_' + (i + 1)]), getters.adjustDate, getters.routerOrderTimeParm.start, beforeLongMap))
      }
      i += 1
    }
    return routerOrderAddData(routerOrders).then((reData) => {
      dispatch('setChooseOrders', {
        cabin_1: null,
        cabin_2: null,
        cabin_3: null,
        cabin_4: null,
        cabin_5: null
      })
      dispatch('loadRouterOrder')
      reData.forEach((item) => {
        dispatch('updateGasOrderData', {id: item.id, dataMap: {emptyHour: item.emptyHour, routerVolume: item.routerVolume, overStockStatus: item.overStockStatus}})
      })
      dispatch('updateAdjustLoadPiTag')
      dispatch('loadSignCar', getters.searchSignCarParm)
      dispatch('setAdjustOrderAddRouterOrdering', false)
      commit('carLineLoadTag')
    }).catch((e) => {
      dispatch('setAdjustOrderAddRouterOrdering', false)
    })
  },
  routerOrderUpdateData ({ commit, dispatch }, data) {
    return routerOrderUpdateData(data.id, data.sort).then(() => {
      dispatch('loadRouterOrder')
      commit('carLineLoadTag')
    })
  },
  routerOrderUpdate ({ commit, dispatch }, data) {
    return routerOrderUpdate(data).then((reData) => {
      commit('carLineLoadTag')
      reData.forEach((item) => {
        dispatch('updateGasOrderData', {id: item.id, dataMap: {emptyHour: item.emptyHour, routerVolume: item.routerVolume, overStockStatus: item.overStockStatus}})
      })
      dispatch('loadRouterOrder')
      dispatch('loadRouterOrderGas')
      dispatch('updateAdjustLoadPiTag')
    })
  },
  routerOrderDeleteData ({ commit, dispatch, getters }, data) {
    return routerOrderDeleteData(data.id).then((reData) => {
      dispatch('loadRouterOrder')
      dispatch('loadRouterOrderGas')
      reData.forEach((item) => {
        dispatch('updateGasOrderData', {id: item.id, dataMap: {emptyHour: item.emptyHour, routerVolume: item.routerVolume, overStockStatus: item.overStockStatus}})
      })
      dispatch('updateAdjustLoadPiTag')
      dispatch('loadSignCar', getters.searchSignCarParm)
      commit('carLineLoadTag')
    })
  },
  setChooseOrders ({ commit }, data) {
    commit('setChooseOrders', data)
  },
  setChooseOrderOne ({ dispatch, commit }, data) {
    commit('setChooseOrderOne', data)
    dispatch('appendCarLine')
  },
  chooseAdjustOrder ({ dispatch, getters }, data) {
    let chooseOrder = getOrderById(getters.allOrder, data)
    dispatch('setChooseAdjustAllOrderData', chooseOrder)
    if (!getters.chooseRouterCar.id) {
      dispatch('showNoticeMsg', {type: 'warning', title: '无法上车', message: '请先选择上车车辆!'})
      return
    }
    dispatch('setAdjustShowRouteOrderType', 'car')
    let carbinList = getters.chooseRouterCar.carbinList || []
    let ok = false
    if (checkCarBin(0, carbinList, chooseOrder) && !getters.chooseOrders.cabin_1) {
      dispatch('setChooseOrderOne', {key: 'cabin_1', data: data})
      ok = true
    } else if (checkCarBin(1, carbinList, chooseOrder) && !getters.chooseOrders.cabin_2) {
      dispatch('setChooseOrderOne', {key: 'cabin_2', data: data})
      ok = true
    } else if (checkCarBin(2, carbinList, chooseOrder) && !getters.chooseOrders.cabin_3) {
      dispatch('setChooseOrderOne', {key: 'cabin_3', data: data})
      ok = true
    } else if (checkCarBin(3, carbinList, chooseOrder) && !getters.chooseOrders.cabin_4) {
      dispatch('setChooseOrderOne', {key: 'cabin_4', data: data})
      ok = true
    } else if (checkCarBin(4, carbinList, chooseOrder) && !getters.chooseOrders.cabin_5) {
      dispatch('setChooseOrderOne', {key: 'cabin_5', data: data})
      ok = true
    } else {
      if (checkCarBin(4, carbinList, chooseOrder) && getters.chooseOrders.cabin_5) {
        dispatch('setChooseOrderOne', {key: 'cabin_5', data: data})
        ok = true
      } else if (checkCarBin(3, carbinList, chooseOrder) && getters.chooseOrders.cabin_4) {
        dispatch('setChooseOrderOne', {key: 'cabin_4', data: data})
        ok = true
      } else if (checkCarBin(2, carbinList, chooseOrder) && getters.chooseOrders.cabin_3) {
        dispatch('setChooseOrderOne', {key: 'cabin_3', data: data})
        ok = true
      } else if (checkCarBin(1, carbinList, chooseOrder) && getters.chooseOrders.cabin_2) {
        dispatch('setChooseOrderOne', {key: 'cabin_2', data: data})
        ok = true
      } else if (checkCarBin(0, carbinList, chooseOrder) && getters.chooseOrders.cabin_1) {
        dispatch('setChooseOrderOne', {key: 'cabin_1', data: data})
        ok = true
      }
    }
    if (!ok) {
      dispatch('showNoticeMsg', {type: 'warning', title: '无法上车', message: '无对应油品车仓!'})
    }
    dispatch('appendCarLine')
  },
  appendCarLine ({ commit, getters }) {
    let appendOrders = Object.keys(getters.chooseOrders).map((carBinNo, carBinNoIndex) => {
      const id = getters.chooseOrders[carBinNo]
      return {
        carBinNoIndex,
        order: id ? getters.allOrder.find(v => v.id === id) : null
      }
    })
    commit('appendCarLine', appendOrders.filter(v => v.order !== null).map(({order, carBinNoIndex}) => {
      return {
        volume: getters.chooseRouterCar.carbinList[carBinNoIndex].validCapacity,
        carId: getters.chooseRouterCar.carbinList[carBinNoIndex].carId,
        carBinNo: getters.chooseRouterCar.carbinList[carBinNoIndex].carBinNo,
        gasTankId: order.gasTankId,
        onWayHour: order.onWayHour,
        backOnWayHour: order.backOnWayHour,
        waitHour: order.waitHour,
        loadHour: order.loadHour,
        validCapacity: order.validCapacity,
        gasId: order.gasId,
        distance: order.distance
      }
    }))
  }
}

const mutations = {
  carLineLoadTag (state) {
    state.carLineLoadTag += 1
  },
  appendCarLine (state, data) {
    state.ordereAppendCarLine = data
  },
  setAdjustOrderAddRouterOrdering (state, data) {
    state.adjustOrderAddRouterOrdering = data
  },
  setRouterOrderTimeParm (state, data) {
    state.routerOrderTimeParm = data
  },
  setRouterOrderLoading (state, data) {
    state.routerOrderLoading = data
  },
  setRouterOrder (state, data) {
    state.routerOrder = data
  },
  setChooseOrders (state, data) {
    state.chooseOrders = data
  },
  setChooseOrderOne (state, {key, data}) {
    state.chooseOrders[key] = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/adjust_order/router_order.js